var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.909,
    height: 57.375,
    viewBox: "0 0 56.909 57.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_129101",
    "data-name": "Group 129101",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_60190",
    "data-name": "Ellipse 60190",
    cx: 9.998,
    cy: 9.998,
    rx: 9.998,
    ry: 9.998,
    transform: "translate(7.634 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_60191",
    "data-name": "Ellipse 60191",
    cx: 5.763,
    cy: 5.763,
    rx: 5.763,
    ry: 5.763,
    transform: "translate(36.965 19.131)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107801",
    "data-name": "Path 107801",
    d: "M138.488,152.925V142.666a15.657,15.657,0,0,1,15.656-15.656h3.828a15.64,15.64,0,0,1,12.67,6.459",
    transform: "translate(-138.488 -98.265)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107802",
    "data-name": "Path 107802",
    d: "M146.244,146.564v-5.217a11.974,11.974,0,0,1,11.976-11.972h0a11.973,11.973,0,0,1,11.972,11.972v4.116",
    transform: "translate(-115.283 -91.189)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.a9b65212eae608d7c66f5dc3951be249.svg";
export { ForwardRef as ReactComponent };